
const initialState = {
  pendingInterventions: [],      
  plannedInterventions: [],
  finishedInterventions: [],  
  canceledInterventions: [],
  refusedInterventions: [],
};

const interventionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PENDING_INTERVENTIONS":
      return { ...state, pendingInterventions: action.payload };
    case "SET_PLANNED_INTERVENTIONS":
      return { ...state, plannedInterventions: action.payload };
    case "SET_CANCELED_INTERVENTIONS":
      return { ...state, canceledInterventions: action.payload };
    case "SET_REFUSED_INTERVENTIONS":      
      return { ...state, refusedInterventions: action.payload };
    case "SET_FINISHED_INTERVENTIONS":      
      return { ...state, finishedInterventions: action.payload };
    default:
      return state;
  }
};
export default interventionReducer;